// extracted by mini-css-extract-plugin
export default {"pagesContainer":"MudarPagina_pagesContainer__OZ-Yl","ativado":"MudarPagina_ativado__+It+n"};